import { v4 as uuid } from 'uuid'
import {
  airDetailsFireFlyQuery,
  airPriceFireFlyQuery,
} from './airPriceFireflyQuery'
import { getNumOfPassengers } from '../../../client/listings-client/services/airSearch/airSearchRequest/helpers.js'
import { getPkgRequest } from '../../../client/details-client/airPrice/helpers'

export function buildRequest({
  priceKey,
  itemKey,
  referrals = {},
  workflowStep,
  isMobile,
  params,
}) {
  return {
    operationName: 'airPriceResponse',
    variables: {
      input: getInputParams({
        priceKey,
        itemKey,
        referrals,
        workflowStep,
        isMobile,
        params,
      }),
    },
    query:
      workflowStep === 'UPSELLS'
        ? airPriceFireFlyQuery
        : airDetailsFireFlyQuery,
  }
}

export function getInputParams({
  priceKey,
  itemKey,
  referrals = {},
  workflowStep,
  isMobile,
  params = {},
  fromPackages,
}) {
  const airPriceMetaInfo = {
    appCode: isMobile ? 'MOBILE' : 'DESKTOP',
    adults: getNumOfPassengers(params['num-adults']) || 1,
    children: getNumOfPassengers(params['num-children']),
    youths: getNumOfPassengers(params['num-youths']),
    infants: getNumOfPassengers(params['num-infants']),
  }

  if (fromPackages) {
    airPriceMetaInfo.pkgRequest = getPkgRequest(params)
  }

  return {
    isPackages: fromPackages,
    itemKey,
    priceKey,
    referrals: {
      refId: referrals.id || 'DIRECT',
      referralSourceId: referrals.sourceId || 'DT',
    },
    transactionId: uuid(),
    requestId: uuid(),
    workflowStep,
    airPriceMetaInfo,
    productId: 1,
    tripType: params['itinerary-type-code'],
  }
}
